import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-badrequest',
  templateUrl: './badrequest.component.html',
  styleUrls: ['../error.component.scss']
})
export class badrequestComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}
